if (!customElements.get('product-sticky-bar')) {
  customElements.define(
    'product-sticky-bar',
    class ProductStickyBar extends HTMLElement {
      constructor() {
        super();
        this.observer = null;
        this.onIntersect = this.handleIntersect.bind(this);
      }

      connectedCallback() {
        if (!('IntersectionObserver' in window)) return;

        const productForm = document.getElementById(this.dataset.formId);
        if (!productForm) return;

        const addButton = productForm.querySelector('[name="add"]');
        if (!addButton) return;

        // rootMargin を下方向へ大きく広げ、「交差している = ボタンがビューポート上端より下にある」
        // 「交差していない = ボタンを通り過ぎた」となるようにする。
        // 通常の rootMargin だと、ボタンが「上端より上」から「下端より下」へ一度も交差せずに
        // 移動した場合(スマホで一気に最上部へ戻るケース)にコールバックが発火せず、バーが消えない。
        this.observer = new IntersectionObserver(this.onIntersect, {
          threshold: 0,
          rootMargin: '0px 0px 100000px 0px',
        });
        this.observer.observe(addButton);
      }

      disconnectedCallback() {
        if (this.observer) {
          this.observer.disconnect();
          this.observer = null;
        }
        this.toggle(false);
      }

      handleIntersect(entries) {
        entries.forEach((entry) => {
          // メインの「カートに追加する」ボタンをスクロールで通り過ぎた時だけ表示する
          // (ボタンより上にいる時・ボタンが見えている時は隠す)。
          // rootMargin を下方向へ広げているため、交差していない = ボタンが上端より上に抜けた状態
          const passed = !entry.isIntersecting && entry.boundingClientRect.top < 0;
          this.toggle(passed);
        });
      }

      toggle(show) {
        this.classList.toggle('product-sticky-bar--visible', show);
        this.setAttribute('aria-hidden', show ? 'false' : 'true');
        document.body.classList.toggle('product-sticky-bar-visible', show);
      }
    }
  );
}
